/**
 *  @class
 *  @function TextWithIconsPageDrawer
 */
if (!customElements.get('text-with-icons-page-drawer')) {
  class TextWithIconsPageDrawer extends HTMLElement {
    connectedCallback() {
      const wrapper = document.getElementById('wrapper');
      const clickCapture = wrapper?.querySelector('.click-capture');

      if (wrapper && clickCapture && this.parentElement !== wrapper) {
        wrapper.insertBefore(this, clickCapture);
      }
    }

    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      this.removeAttribute('inert');
      this.focus();
    }

    close() {
      document.body.classList.remove('open-cc');
      this.classList.remove('active');
      this.setAttribute('inert', '');
    }
  }

  customElements.define('text-with-icons-page-drawer', TextWithIconsPageDrawer);
}

/**
 *  @class
 *  @function TextWithIconsBlock
 */
if (!customElements.get('text-with-icons-block')) {
  class TextWithIconsBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);

      if (!this.drawer) {
        return;
      }

      this.addEventListener('click', this.openDrawer.bind(this));
    }

    openDrawer() {
      if (!this.drawer || this.drawer.classList.contains('active')) {
        return;
      }

      if (typeof this.drawer.open === 'function') {
        this.drawer.open();
      }
    }
  }

  customElements.define('text-with-icons-block', TextWithIconsBlock);
}
